import { react2angular } from '@Shared.Angular/flowingly.helper/react2angular';
import { Governance } from '../components/Governance/Governance';
const GovernanceBridge = react2angular(Governance, [
  'isMobile',
  'onListItemClicked'
]);
export default GovernanceBridge;
